module.exports = __webpack_public_path__ + "static/data_bar_6-f8298b3f8ca31bda913076f358ec81db.png";